// extracted by mini-css-extract-plugin
export default {"toastComponent":"ToastComponent_toastComponent__J5sQ5"};